import React from 'react';
import { PostEditorForm, PostsEditor } from './PostsEditor';
import { PostTypes } from '../Post.types';

export type PostsEditorWithUpload = {
  form: PostEditorForm;
  type: PostTypes;
  postId: string;
  autoFocus?: boolean;
};

/**
 * Wrapper for the Posts RichText Editor with Upload
 */
export function PostsEditorWithUpload({ form, type, autoFocus, postId }: PostsEditorWithUpload) {
  return <PostsEditor form={{ ...form, url: form.url }} type={type} autoFocus={autoFocus} uuid={postId} />;
}
